import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { PopupModal } from "react-calendly";
import { ArrowRight } from "lucide-react";

// Autumn 2026 sale hero: 50% off + 40% off
function Hero() {
  const [openBooking, setOpenBooking] = useState(false);

  return (
    <section className="relative bg-[#d2b08a] overflow-hidden">
      {/* Mobile: image only (text is baked into the artwork), whole image links to the shop */}
      <Link to="/shop" className="block md:hidden">
        <img
          src="/images/autumn_2026_mobile.webp"
          alt="Autumn Looks Good On You - 50% off + 40% off custom shades. Shop now and save."
          fetchpriority="high"
          className="w-full h-auto"
          width={2416}
          height={3952}
        />
      </Link>

      {/* Desktop: artwork sets the height (full width, natural 1920x769 ratio); text scales with the viewport */}
      <div className="relative hidden md:block">
        <img
          src="/images/autumn_2026.webp"
          alt=""
          aria-hidden="true"
          fetchpriority="high"
          className="block w-full h-auto"
          width={1920}
          height={769}
        />
        <div className="absolute inset-0 flex items-center">
          <div className="pl-[10vw] text-left font-poppins">
            <motion.h1
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              className="tracking-tight"
            >
              <span className="block text-white font-semibold text-[1.15vw] tracking-wide mb-[0.5vw] drop-shadow-sm">
                Refresh your windows. Refresh your space.
              </span>
              <span className="block text-white font-semibold leading-[1.02] text-[3.75vw] drop-shadow-sm">
                Autumn Looks
                <br />
                Good On You.
              </span>
              <span className="mt-[0.8vw] flex items-end gap-[0.6vw] text-gray-900 font-semibold leading-none">
                <span className="flex items-stretch">
                  <span className="text-[3.9vw] leading-none">50</span>
                  {/* % and OFF stacked tight, centered on the digit height */}
                  <span className="flex flex-col justify-center gap-0 items-center ml-[0.25vw] pt-[0.35vw] pb-[0.75vw] leading-none">
                    <span className="text-[1.9vw] leading-none font-bold inline-block scale-x-125 origin-center">
                      %
                    </span>
                    <span className="text-[1.1vw] font-bold tracking-wide leading-none -mt-[0.2vw]">
                      OFF
                    </span>
                  </span>
                </span>
                <span className="text-[3vw] leading-none pb-[0.3vw]">+</span>
                <span className="flex items-stretch">
                  <span className="text-[3.9vw] leading-none">40</span>
                  {/* % and OFF stacked tight, centered on the digit height */}
                  <span className="flex flex-col justify-center gap-0 items-center ml-[0.25vw] pt-[0.35vw] pb-[0.75vw] leading-none">
                    <span className="text-[1.9vw] leading-none font-bold inline-block scale-x-125 origin-center">
                      %
                    </span>
                    <span className="text-[1.1vw] font-bold tracking-wide leading-none -mt-[0.2vw]">
                      OFF
                    </span>
                  </span>
                </span>
              </span>
            </motion.h1>

            {/* CTAs */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3, ease: "easeOut" }}
              className="mt-[1.6vw] flex flex-row items-center"
            >
              {/* Text link instead of a filled button: letter-spaced caps over a hairline */}
              <Link
                to="/shop"
                className="group inline-flex items-center gap-[0.6vw] border-b border-gray-900 pb-[0.35vw] text-gray-900 uppercase tracking-[0.2em] font-semibold text-[0.85vw] leading-none"
              >
                Shop Now &amp; Save
                <ArrowRight
                  aria-hidden="true"
                  strokeWidth={1.5}
                  className="w-[1vw] h-[1vw] transition-transform duration-300 group-hover:translate-x-[0.3vw]"
                />
              </Link>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Calendly Popup Modal */}
      <PopupModal
        url="https://calendly.com/offcutshades"
        rootElement={document.getElementById("root")}
        open={openBooking}
        onModalClose={() => setOpenBooking(false)}
      />
    </section>
  );
}

export default Hero;
